export default __webpack_public_path__ + "static/img-44c381f439eca41f89faf4ee12c17a12.jpg";